export const logo = {
  fontFamily: "Space Grotesk",
};
